import _ from 'lodash';

export const isValidMongoId = (id?: string): boolean => {
  const mongoIdPattern = /^[0-9a-fA-F]{24}$/;
  return !_.isNil(id) && mongoIdPattern.test(id);
};

export const tryToStringify = (value: any, fallback?: string): string | undefined => {
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return fallback;
  }
};
